import { Colors } from "@/components/common";

const evaluationStatusCodes = {
  pending: 1,
  accepted: 2,
  acceptedCoordinated: 3,
  accomplished: 4,
  excluded: 5
};

const appointmentStatusCodes = {
  approved: 0,
  coordinated: 1,
  acceptedCoordinated: 2
};

const evaluationStatusString = {
  1: "Pendiente",
  2: "Aceptada",
  3: "Aceptada-Coordinada",
  4: "Cumplida",
  6: "Excluida"
};

const getEvaluationStatusColor = (statusId, isHexColor = true) => {
  switch (statusId) {
    case evaluationStatusCodes.pending:
      return isHexColor ? "#FAE76F" : Colors.YELLOW;

    case evaluationStatusCodes.accepted:
    case evaluationStatusCodes.acceptedCoordinated:
      return isHexColor ? "#A4E5B2" : Colors.GREEN_LIGHT;

    case evaluationStatusCodes.accomplished:
      return isHexColor ? "#A4E5B2" : Colors.GREEN_LIGHT;

    case evaluationStatusCodes.excluded:
      return isHexColor ? "#ddb3d7" : Colors.VIOLET;
  }
};

// TODO: Mejorar esto por IDs cuando se integre con BE.
const sources = {
  discussionPending: 1,
  reevaluationRecommended: 2
};

const getEvaluationBackgroundClass = (sourceId, isDiscussionPending = true) => {
  let resultClass = "discussion-pending";
  
  if(sourceId == sources.reevaluationRecommended && !isDiscussionPending){
    resultClass = "reevaluation-recommended";
  }

  return resultClass;
};

export {
  evaluationStatusCodes,
  evaluationStatusString,
  getEvaluationStatusColor,
  sources,
  getEvaluationBackgroundClass,
  appointmentStatusCodes
};
